import { useTodayFeed } from '../hooks/useFeed';
import FeedCard from '../components/FeedCard';

export default function Today() {
  const { data, isLoading, error } = useTodayFeed();

  if (isLoading) {
    return (
      <div className="flex justify-center py-16">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-teal/20 border-t-teal" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="card p-8 text-center text-danger">
        Chyba načítání feedu: {(error as Error).message}
      </div>
    );
  }

  const run = data?.run;
  const items = data?.items ?? [];

  if (!run || items.length === 0) {
    return (
      <div className="card p-8 text-center">
        <h1 className="mb-3 font-heading text-2xl text-dark">Dnešní feed</h1>
        <p className="text-sm text-gray-600">
          Feed se připravuje. Denní ingest běží ráno před 7:00 UAE time.
          Pokud má v terminálu admin běžet ingest ručně, použij{' '}
          <code className="rounded bg-gray-100 px-1 text-xs">npm run ingest</code>.
        </p>
      </div>
    );
  }

  return (
    <div>
      <header className="mb-6">
        <h1 className="font-heading text-3xl font-semibold text-dark">Dnešní feed</h1>
        <p className="mt-1 text-sm text-gray-500">
          {formatDateLong(run.startedAt)} · {items.length}{' '}
          {items.length === 1 ? 'zpráva' : items.length < 5 ? 'zprávy' : 'zpráv'}
        </p>
      </header>

      <div className="space-y-4">
        {items.map((item) => (
          <FeedCard key={item.id} item={item} />
        ))}
      </div>
    </div>
  );
}

function formatDateLong(unixSec: number): string {
  const d = new Date(unixSec * 1000);
  const days = ['neděle', 'pondělí', 'úterý', 'středa', 'čtvrtek', 'pátek', 'sobota'];
  const months = [
    'ledna', 'února', 'března', 'dubna', 'května', 'června',
    'července', 'srpna', 'září', 'října', 'listopadu', 'prosince',
  ];
  return `${days[d.getDay()]}, ${d.getDate()}. ${months[d.getMonth()]} ${d.getFullYear()}`;
}
